exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-date-editor--month{width:120px!important}.time,.time .el-date-editor{width:220px!important}", ""]);

// exports
